export const DEFAULT_CID_VERSION = 1
export const DEFAULT_SHARD_HASH_CODE = BigInt(0x22)
export const DEFAULT_SHARD_FANOUT_BITS = 8
export const DEFAULT_SHARD_SPLIT_THRESHOLD_BYTES = 262_144
export const DEFAULT_SHARD_SPLIT_STRATEGY = 'links-bytes'
export const DEFAULT_CHUNK_SIZE_256KIB = 262_144
export const DEFAULT_CHUNK_SIZE_1MIB = 1_048_576
export const DEFAULT_FILE_IMPORT_CONCURRENCY = 50
export const DEFAULT_BLOCK_WRITE_CONCURRENCY = 10
export const DEFAULT_REDUCE_SINGLE_LEAF_TO_SELF = true
export const DEFAULT_RAW_LEAVES = true
export const DEFAULT_WRAP_WITH_DIRECTORY = false
export const DEFAULT_LEAF_TYPE = 'file'
